import CompanyScreen from './containers/companyScreen'

export {default as CompanyScreenLayout} from './components/companyScreenLayout'

export default CompanyScreen
